import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, CircleMarker, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { useHistory } from 'react-router-dom';
import ApiClient from '../../../methods/api/apiClient';

const mapStyle = { width: '100%', height: '280px', borderRadius: '0 0 8px 8px' };
const center = [39.8283, -98.5795];

const trackingColors = {
  live: '#27ae60',
  stale: '#f39c12',
  offline: '#e74c3c',
  no_gps: '#95a5a6'
};

const FleetOverview = () => {
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    ApiClient.get('fleet/tracking').then(res => {
      if (res?.success) {
        setData(res.data || []);
        setSummary(res.summary || {});
      }
      setLoading(false);
    });
  }, []);

  const mappable = data.filter(l => l.last_gps_lat && l.last_gps_lng);

  return (
    <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
      {/* Header */}
      <div style={{ padding: '14px 16px', borderBottom: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h6 style={{ margin: 0, fontWeight: 600, fontSize: 15 }}>
          <i className="fa fa-map-marker" style={{ color: '#3E549D', marginRight: 8 }}></i>
          Fleet Overview
        </h6>
        <button
          onClick={() => history.push('/tracking')}
          style={{ background: 'none', border: '1px solid #3E549D', color: '#3E549D', borderRadius: 4, padding: '3px 12px', fontSize: 11, fontWeight: 600, cursor: 'pointer' }}
        >
          Full Map &rarr;
        </button>
      </div>

      {/* Stats Row */}
      <div style={{ display: 'flex', padding: '10px 16px', gap: 12, borderBottom: '1px solid #eee' }}>
        <div style={{ flex: 1, textAlign: 'center' }}>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#3E549D' }}>{summary.total || 0}</div>
          <div style={{ fontSize: 10, color: '#888' }}>Active</div>
        </div>
        <div style={{ flex: 1, textAlign: 'center' }}>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#27ae60' }}>{summary.in_transit || 0}</div>
          <div style={{ fontSize: 10, color: '#888' }}>In Transit</div>
        </div>
        <div style={{ flex: 1, textAlign: 'center' }}>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#f39c12' }}>{summary.pickedup || 0}</div>
          <div style={{ fontSize: 10, color: '#888' }}>Picked Up</div>
        </div>
        <div style={{ flex: 1, textAlign: 'center' }}>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#27ae60' }}>{summary.live_tracking || 0}</div>
          <div style={{ fontSize: 10, color: '#888' }}>Live GPS</div>
        </div>
      </div>

      {/* Mini Map (Leaflet + OpenStreetMap) */}
      {loading ? (
        <div style={{ height: 280, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999' }}>
          <i className="fa fa-spinner fa-spin fa-2x"></i>
        </div>
      ) : (
        <MapContainer
          center={center}
          zoom={4}
          scrollWheelZoom={false}
          style={mapStyle}
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>'
            url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png"
            subdomains={['a', 'b', 'c', 'd']}
            maxZoom={19}
          />
          {mappable.map(load => (
            <CircleMarker
              key={load.id}
              center={[parseFloat(load.last_gps_lat), parseFloat(load.last_gps_lng)]}
              radius={7}
              pathOptions={{
                color: '#fff',
                weight: 1.5,
                fillColor: trackingColors[load.tracking_status] || '#95a5a6',
                fillOpacity: 1
              }}
            >
              <Tooltip direction="top" offset={[0, -4]}>
                #{load.load_id} - {load.carrier?.name || 'N/A'}
              </Tooltip>
            </CircleMarker>
          ))}
        </MapContainer>
      )}

      {/* Legend */}
      <div style={{ padding: '8px 16px', display: 'flex', gap: 16, fontSize: 10, color: '#888' }}>
        <span><span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', background: '#27ae60', marginRight: 4 }}></span>Live</span>
        <span><span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', background: '#f39c12', marginRight: 4 }}></span>Stale</span>
        <span><span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', background: '#e74c3c', marginRight: 4 }}></span>Offline</span>
        <span><span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', background: '#95a5a6', marginRight: 4 }}></span>No GPS</span>
      </div>
    </div>
  );
};

export default FleetOverview;
